import { WorkerTimesheetStatusCountFragment } from '@common/graphql/schema';
import { capitalize } from 'lodash';

const defaults: WorkerTimesheetStatusCountFragment[] = (
  [
    'not_submitted',
    'submitted',
    'approved',
    'processing',
    'invoiced',
    'overdue',
    'expired',
    'rejected',
    'all',
  ] as const
).map((status) => ({ id: status, name: capitalize(status), value: 0 }));

export const useDefaultTimesheetTabCounts = () => defaults;
